import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from './isFeatureEnabled';
import isGetScheduleEnabled from './isGetScheduleEnabled';

export default function (
    mailboxInfo: MailboxInfo,
    dontThrowErrorIfNotInitialized?: boolean
): boolean {
    return (
        isAccountFeatureEnabled(
            'cal-hybrid-working-hours',
            mailboxInfo,
            dontThrowErrorIfNotInitialized
        ) && isGetScheduleEnabled(mailboxInfo, dontThrowErrorIfNotInitialized)
    );
}
